$(function(){
  setupClicks();
  setupMaximizeButton();
  setupHideAfterClick();
  setupConfirmAction();
  setupHideOnClick();
  setupPreventDefaults();
  setupShowHideDiv();
  showHide();
  showHide2();
  settingsNav();
  setupLastGamesClick();
  showMoreRows();
  setupScrollToContent();
  setupLoadFromARES();
  setupLightbox();
  setupDivisionRename();
  setupHomepageGA();
  setupCalcGA();
  setupCopyClick();
  setupFileUploadButton();
  setupTableTrToggle();


  if($('#divisionPlayersTable').length > 0) {
    setupDivisionPlayersBulkActions();
  }
  
  
  if ($('.playertheory').length > 0) {  // on Theory page only
    handleSectionBtn('#section-fingering-btn');
  }

  // @TODO finish translations
  $('.loginAsLink').click(function(e) {
    if (!confirm('Opravdu se přihlásit jako tento uživatel?')) {
      e.preventDefault();
    }
  });

  $('.deleteAdminFromInstitutionLink').click(function(e) {
    if (!confirm('Opravdu odstranit tohoto správce? (jeho účet nebude smazán)')) {
      e.preventDefault();
    }
  });

  $('.deleteInvitationLink').click(function(e) {
    if (!confirm('Opravdu smazat tuto pozvánku?')) {
      e.preventDefault();
    }
  });

  $('.slideUpOnClick').click(function(e) {
    var elementToClose = $(this).attr('data-closeTarget') ? $($(this).attr('data-closeTarget')) : $(this);
    elementToClose.slideUp();
  });

  if ($('.print').length > 0) {  // on print page only
    $('.printButton').click(function(){
      window.print();
    });
  }


})


let setupDivisionPlayersBulkActions = () => {


  let bulkActionContainer = $("#bulk-action-select-container");
  let selectAllCheckbox = $("#selectAllCheckbox");
  let submitButton = $("#submit-button");


  bulkActionContainer.show();
  $('#divisionToMoveIn-select').hide();
  $('#licenceCategory-select').hide();




  //Disable bulk-action when it is not available for current player
  let disableNotAvailableActions = (disableCheckbox = true, showContainer = true) => 
  {

    let disableNotAvailableAction = (actionName, notAvailableClass, selectedOption) => 
    {

      if(selectedOption == actionName) 
      {
        
        $('.bulk-action-checkbox').each((index, checkbox) => 
        {
          if($(checkbox).hasClass(notAvailableClass)) 
          {
            $(checkbox).prop('checked', false).attr('disabled', true);
          } 
          else {
            $(checkbox).attr('disabled', false);
            if(selectAllCheckbox.prop('checked') == true) 
            {
              $(checkbox).prop('checked', true);
            }
          }
        });

        return true;

      }


      return false;

    }


    let selectedOption = $('#bulk-action-select').find(':selected').val();

    rule1Applied = disableNotAvailableAction('addLicence', 'cant-extend-licence', selectedOption);
    rule2Applied = disableNotAvailableAction('downloadCertificate', 'cant-download-certificate', selectedOption);

    //Clear disabled checkboxes if no rule was applied
    if(!rule1Applied && !rule2Applied) 
    {
      $('.bulk-action-checkbox').each((index, checkbox) => 
      {
        
        $(checkbox).attr('disabled', false);
        if(selectAllCheckbox.prop('checked') == true) 
        {
          $(checkbox).prop('checked', true);
        }

      });
    }

  
    if(showContainer && disableCheckbox !== false) { showBulkActionContainer(); }

  }




  //On click on select all checkbox
  let selectAllCheckboxFunction = () => 
  {
    $('.bulk-action-checkbox').each((index, checkbox) => {
      $(checkbox).prop("checked", selectAllCheckbox.prop("checked"));
    });

    disableNotAvailableActions();

    if(selectAllCheckbox.prop("checked") == false) {
      disableNotAvailableActions(false);
    }
  }


  //On click on single bulk action checkbox
  let bulkActionCheckboxFunction = (checkbox) => 
  {
    showBulkActionContainer();    
  }


  //On bulk actions select change
  let bulkActionSelectFunction = (e) => 
  {
    let selectedOption = $(e.target).find(':selected').val();

    showAdditionalSelect(selectedOption, 'movePlayer', 'divisionToMoveIn');
    showAdditionalSelect(selectedOption, 'addLicence', 'licenceCategory');

    disableNotAvailableActions();
  }

  

  let showAdditionalSelect = (selectedOption, type, selectName) => 
  {
    if(selectedOption == type) {
      $('#' + selectName + '-select').show();
    } else {
      $('#' + selectName + '-select').hide();
    }
  }


  let showBulkActionContainer = () => 
  {

    let checkedCheckboxesCount = $('.bulk-action-checkbox:checked').length
    
    if(checkedCheckboxesCount == 0) 
    { 
      submitButton.prop('disabled', true);
      
      $('#divisionToMoveIn-select').hide();
      $('#licenceCategory-select').hide();
      
      selectAllCheckbox.prop("checked", false);

      disableNotAvailableActions(true, false);
    }
    else 
    {
      
      submitButton.prop('disabled', false);

      let selectedOption = $('#bulk-action-select').find(':selected').val();
      
      showAdditionalSelect(selectedOption, 'movePlayer', 'divisionToMoveIn');
      showAdditionalSelect(selectedOption, 'addLicence', 'licenceCategory');

    }

  }




  selectAllCheckbox.on('click', () => selectAllCheckboxFunction());

  $('.bulk-action-checkbox').on("click", (e) => bulkActionCheckboxFunction(e.target));

  $('#bulk-action-select').on('change',  (e) => bulkActionSelectFunction(e));


  disableNotAvailableActions();

}




function setupLightbox() {
  
  $('.lightboxOpen').click(function(e) {
    e.preventDefault();


    var modal = $($(this).attr('data-target'));
    var video = $('video', modal)[0];
    
    modal.modal({show: true});
    video.play();
    modal.on('hide.bs.modal', function (e) {
      video.pause();
    });
  });
}

function setupScrollToContent() {

  const target = $(window.location.hash);
  if(target.length > 0) { scrollTo(target);}

  $('.scrollToContent').bind('click', function(e) {
    e.preventDefault();
    const target = $($(this).attr('data-target'));

    scrollTo(target);
  });

  function scrollTo(target) {
    $("html, body").animate(
      { scrollTop: $(target).offset().top },
      500);
  }

}

function setupLoadFromARES() {

  $(document).on('click', '.loadFromARES', function() {
    loadFromARESFunction(this);
  });


  const loadFromARESInput = function() {
    
    if($('.loadFromARESInput').val().length == 8) 
    {
      isNoInputVersion = $('.ARESSettings').attr('data-isNoInputVersion');
      loadFromARESFunction('.ARESSettings', isNoInputVersion);
    }
  } 

  if($('.loadFromARESInput').is(":visible")) { loadFromARESInput(); }
  
  $('.loadFromARESInput').on('keyup', function() {
    $('.ARES').hide();
    loadFromARESInput();
  });
}

function loadFromARESFunction(element, isNoInputVersion) {

  const form = $(element).closest('form');
  const errorMessage = $(element).attr('data-errorMessage');

  if ($('input[name=ico]', form).val() == "") {
    alert(errorMessage);
    return;
  }

  $('.ares-spinner').removeClass('invisible');

  $.post(
      $(element).attr('data-href'), 
      {'ico': $('input[name=ico]', form).val()}, 
      function(data) {

        if(!data.result) 
        {
          $('.ares-spinner').addClass('invisible');
          (new SingleInputValidation($('#frm-CreateSchoolOrderForm-form-ico'))).invalidateInput(errorMessage);
          $('.ARES').hide();
          return;
        }

        $('.ARES').show();

        $.each(data.result, function(index, value) 
        {
          var name = index.replace('invoice', '');
          name = name.charAt(0).toLowerCase() + name.substr(1);

          if (name == 'dIC') {
            name = 'dic';  // exception
          } 

          if(isNoInputVersion) {
            $('.ARES-' + name).text(value);
          } else {
            $('input[name='+name+']', form).val(value);
          }
        });

        $('.ares-spinner').addClass('invisible');
      }
    );

}


function setupLastGamesClick() {
  $('.showNextLastGames').click(function(e) {
    e.preventDefault();
    $(this).hide();
    $(this).closest('table').find('tr.moreThan10').removeClass('hidden'); 
  });
}

/** Hides all but first N rows of a table and adds a link to the bottom for showing all rows. */
function showMoreRows() {
  var table = $('table.showOnlyFirstRows');
  if (table.length == 0) return;

  table.each(function() {
    var thisTable = $(this);
    var rowsToShow = parseInt(thisTable.attr('data-rowsShown'));
    $('tr:gt('+rowsToShow+')', thisTable).hide(); 

    var linkText = thisTable.attr('data-linkShowMore') || 'Show all';
    var colspan = $('tr:first th', thisTable).length;
    $('tbody', thisTable).append('<tr class="showAll"><td colspan="'+colspan+'" class="text-align-center"><a href="javascript: void(0)">' + linkText + '</a></td></tr>');  
    
    $('.showAll a', thisTable).click(function() {
      $('tr', thisTable).show();
      $('tr.showAll', thisTable).hide();
    })
  })
  
}

function setupPreventDefaults(){
  $('.onclick-prevent-default').click(function(e){
    e.preventDefault()
  })
}

function setupHideOnClick(){
  $('.hide-on-click').click(function(){
    var t = $(this);
    var target = $(t.data('hidetarget'))
    target.css('overflow', 'hidden').animate({
      height: 0
    },{
      duration: 300
    });
  });
}

function setupConfirmAction() {
  $(".action-confirmation").click(function(e) {
    
    var confirmText = $(this).attr('data-confirmText') || localizedTexts.dev.confirmation;

    if (!confirm(confirmText)) {
      e.preventDefault();
      e.stopImmediatePropagation(); // it does not work without this
    }
  });
}

function setupHideAfterClick(){
  $('.hide-after-click').click(function(){
    var t = $(this)
    t
      .addClass('default-transition')
      .addClass('overflow-hidden')
      .addClass('max-height-0');
    if(t.hasClass('remove')){
      setTimeout(function(){t.remove()}, 300);
    }
  });
}

function scrollToTop(jump){
  if(!jump) $("html, body").animate({ scrollTop: 0 }, "slow");
  else $('html,body').scrollTop(0);
}

function setupMaximizeButton() {
  $('.maximize-btn').click(function(){
    var t = $(this);
    $(this).hide()
      .closest('.minimize')
      .addClass('maximize')
      .removeClass('minimize');
  });
}

function setupClicks(){
  $('.quick-contact-plus, .quick-contact-heart').click(function(){$('.heart-content').toggleClass('collapsed');});
  $('.btnStartPlay').click(startPlay);
  $('a.round.disable').click(function(e){e.preventDefault();});
  $('a[data-showPopup=1]').click(function(e){
    e.preventDefault();
    var modalName = $(this).attr('data-target');
    $(modalName).modal('show');
  });
  $('a[data-showPurchasePopup=1]').click(showPurchasePopup);

  $('.section-button').click(handleSectionBtn);
  $('.codebox').hide();
  $('.applyDiscountCode').click(payboxCodeClick);
}

function showPurchasePopup(e) {
  
  e.preventDefault();

  var modalName = $(this).attr('data-target');
  var headerText = $(this).attr('data-headerText');
  var header = $(modalName).find('#headerText');
  
  if (headerText) {   // back up the original text and replace it with headerText provided
    if (!header.data('originalText')) {
      header.data('originalText', header.html());
    }
    header.html(headerText);
  }
  else if (header.data('originalText')) {   // restore the original text
    header.html(header.data('originalText'));
    header.removeData('originalText');
  }
  
  $(modalName).modal('show');
}

function startPlay(){
  $('.btnStartPlay').addClass('hidden');
  $('.game').removeClass('hidden');
  $('.keyboard-help').removeClass('hidden');
  $('.rounds-helps').addClass('hidden');

  $.post($('.btnStartPlay').attr('data-helpHiddenNotifyUrl'));
}

function handleSectionBtn(id){

  var $el = typeof id == 'string' ? $(id) : $(this);
  $('.section-button').removeClass('selected');
  $el.addClass('selected');
  $target = $('#' + $el.data('target'));
  $container = $('#' + $el.data('container'));
  $container.html($target.html());
  $("html, body").animate({ scrollTop: 0 }, "slow");
}

function payboxCodeClick(e){
  e.preventDefault();
  $(this).addClass('hidden');
  $(this).next('.codebox').slideDown();
  //.removeClass('hidden')

  $('.checkCode').click(function(e) {
    e.preventDefault();
    
    var code = $('.code', $(this).closest('.codebox')).val();
    if (!code) {
      alert(localizedTexts.dev.noDiscountCode);
      return;
    }

    var licencesCount = $('#certificateCount').length > 0 ? $('#certificateCount').val() : 1;

    $.post(baseUrl+'/check-code', {'code': code, 'licencesCount': licencesCount}, function(data) {
      if (!data || !data.result) {
        alert(localizedTexts.dev.connectionError);
        return;
      }

      if (data.result.codeState == 'redeemed') {
        alert(localizedTexts.dev.usedCodeInfo);
        return;
      }
      
      if (data.result.codeState == 'expired') {
        alert(localizedTexts.dev.validityCodeInfo);
        return;
      }
      
      if (data.result.codeState == 'invalid') {
        alert(localizedTexts.dev.notValidCodeInfo);
        return;
      }
      
      if (data.result.codeState == 'valid') {
        $('.paybox .price').text(data.result.priceAfterDiscount);
        if (data.result.discount == 100) {
          $('.paybox input[type=submit]').val(localizedTexts.dev.continue);
          $('#paymentNote').hide();
        }
        $('.paybox .discountInfoDiv').removeClass('hidden');
        $('.paybox .discountInfo').text(data.result.discountText);
        if (data.result.discountForFirstOnly) {
            $('.paybox .discountInfoDiv2').removeClass('hidden')
        }
        else {
            $('.paybox .discountInfoDiv2').addClass('hidden');
        }
        $('#discountInfo').addClass('hidden');

        $('input[name=code]').val($('.code').val());  // transfer to the hidden field in the form
      }
    })
  })
}

function setupRadios(){
  $('.unselected').click(function(){
    $('.selected').removeClass('selected').addClass('unselected');
    $(this).removeClass('unselected').addClass('selected');
    scrollToTop(true);
  });
  $('.selected').click(function(){
    $('.selected').removeClass('selected').addClass('unselected');
    $(this).removeClass('unselected').addClass('selected');
    scrollToTop(true);
  });
}

//show hide div (page: player/player-statistics)
function setupShowHideDiv() {
    $('.table-sumary-top').on('click', function() {
    	
      $parent_box = $(this).closest('.table-sumary-box');

      if($(this).attr('data-hideOther') === 'true') 
      {
        $('.table-sumary-box').each(function() {
          if($parent_box[0] !== $(this)[0]) { toggleTableSumary($(this), 'hide'); }
        });
      }

      toggleTableSumary($parent_box);
    });

    const toggleTableSumary = function($parent_box, type = 'toggle') 
    {
      if(type === 'hide') { $parent_box.find('.table-sumary-bottom').hide(); }
      else { $parent_box.find('.table-sumary-bottom').toggle(); }
        
        if($parent_box.find('.table-sumary-item').hasClass('rotate-90-deg') || type === 'hide') {
            $parent_box.find('.table-sumary-item').removeClass('rotate-90-deg');
            $parent_box.find('.table-sumary-item').addClass('rotate--90-deg');
            $parent_box.find('.table-sumary-top').removeClass('bg-color-gray');
        } else {
            $parent_box.find('.table-sumary-item').removeClass('rotate--90-deg');
            $parent_box.find('.table-sumary-item').addClass('rotate-90-deg');
            $parent_box.find('.table-sumary-top').addClass('bg-color-gray');
        }
    }
}


function setupTableTrToggle() {
  $('.table-tr-toggle-top, .table-tr-toggle-bottom').on('click', function() {

    const group = $(this).data('group');

    const top = $(`.table-tr-toggle-top[data-group="${group}"]`);
    const bottom = $(`.table-tr-toggle-bottom[data-group="${group}"]`);

    top.toggleClass('bg-color-gray');
    $(`.table-tr-toggle-top:not([data-group="${group}"])`).removeClass('bg-color-gray');

    top.find('.table-sumary-item').toggleClass('rotate-90-deg').toggleClass('rotate--90-deg');
    $(`.table-tr-toggle-top:not([data-group="${group}"])`).find('.table-sumary-item').removeClass('rotate-90-deg').addClass('rotate--90-deg')
    
    bottom.toggle();
    $(`.table-tr-toggle-bottom:not([data-group="${group}"])`).hide();
  });



}


function showHide(e){
    $('.item1').on('click', function() {
        $parent_box = $(this).closest('.showHide');
        $parent_box.find('.item2').removeClass('hidden');
        $parent_box.find('.item1').addClass('hidden');
    });
    
    $('.item3').on('click', function() {
        $parent_box2 = $(this).closest('.showHide');
        $parent_box2.find('.item2').addClass('hidden');
        $parent_box2.find('.item1').removeClass('hidden');
    });
 }

function settingsNav() {
  $('.section-button2 a').on('click', function () {
    $('.section-button2').removeClass('selected');
    $(this).parent().addClass('selected');
    $('.section').addClass('hidden');
    $('#' + $(this).data('target')).removeClass('hidden');

  });
}

function showHide2(e){
  $('.button-show').on('click', function() {
    if($(".item-sh").hasClass('hidden')){
      $(".item-sh").addClass('visible').removeClass('hidden');
      $(".item-h").addClass('hidden').removeClass('visible');
    } else {
      $(".item-sh").addClass('hidden').removeClass('visible');
      $(".item-s").addClass('visible').removeClass('hidden');
    }
  });
}

function setupDivisionRename() {

  $('.renameDivisionBtn').click(function() {

    $('.renameDivisionBtn').show();
    $('.renameDivisionBtn').closest('.division-name').show();
    $('.renameDivisionForm').addClass('hidden');

    $(this).hide();
    $(this).closest('.division-name').hide();

    var editForm = $(this).attr('data-target');

    $(editForm).removeClass('hidden');

    $('.submit-rename').click(function() {
      $(editForm).submit();
    })

    $('.cancel-rename').click(function() {
      $(editForm).addClass('hidden');

      $('.renameDivisionBtn').show();
      $('.renameDivisionBtn').closest('.division-name').show();
    })

  })

}

function sendSpeedTestCTA_GA() {
  if($('#testgame').length > 0) {
    if(isGaSet) {
      ga('send', 'event', 'speedTest', 'speedTestCTA', 'Speed test CTA viewed');
    }
  }
}

function  setupHomepageGA() {

  $('.homepageCTA').click(function() {

    var hpModule = 'none';

    if(!$(this).hasClass('input')) {
      var ctaText = $(this).text();
      var ctaSection = 'section #' + ($(this).closest('section').attr('id') ? $(this).closest('section').attr('id') : 'no sections');

    } else {
      var ctaText = $(this).val();
      var ctaSection = 'form #' + $(this).closest('form').attr('id');

    }

    var ctaValue = $(this).attr('data-gaValue') ? $(this).attr('data-gaValue') : null;

    
    //alert(hpModule + 'HomepageCTA' + '----' + 'cta-' + ctaText + '----' + 'CTA in ' + ctaSection + " clicked" + '----' + ctaValue);

    if(isGaSet) {
      ga('send', 'event', hpModule + 'HomepageCTA', 'cta-' + ctaText, 'CTA in ' + ctaSection + " clicked", ctaValue);
    }


  });


}

function setupCalcGA() {

  $('.calculator-btn').click(function() {

    var hpModule = 'none';
    var btnText = $(this).text().replace(/\s\s+/g, ' ').trim();
    var calcSection = 'section ' + ($(this).closest('.row').attr('data-calcSection')) + ' ';


    //alert(hpModule + 'Calc' + '----' + 'btn-' + btnText + '----' + 'CTA in ' + calcSection + 'clicked');

    if(isGaSet) {
      ga('send', 'event', hpModule + 'Calc', 'btn-' + btnText, 'Btn in ' + calcSection + " clicked");
    }

  })

  var calcInputDelay;

  $('.calculatorInput').change(function() {

    var input = $(this);

    clearTimeout(calcInputDelay);

    calcInputDelay = setTimeout(function() {

      var hpModule = 'none';
      var btnText = input.attr('name');
      var calcSection = 'section ' + (input.closest('.row').attr('data-calcSection')) + ' ';
      var inputValue = input.val();

      //alert(hpModule + 'Calc' + '----' + 'btn-' + btnText + '----' + 'CTA in ' + calcSection + 'clicked' + '----' + inputValue);

      if(isGaSet) {
        ga('send', 'event', hpModule + 'Calc', 'btn-' + btnText, 'Input in ' + calcSection + " used", inputValue);
      }

    }, 5000);   

  });
}

function setupCopyClick() {

  $('.copyBtn').click(function() {

    var copyText = $(".copyLink").val();
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
  });
  
}


function setupFileUploadButton() {
  $('.upload-button').on('change', function() {   
    $('.file-name').text(this.files[0].name);
    $('.file-upload-label').addClass('show-filename');
  });
}